
<script>

export default {
    props: {
        o: {
            type: [String, Number],
            default: ''
        },
        n: {
            type: [String, Number],
            default: ''
        },
        f: {
            type: [String, Number],
            default: ''
        },
    }
}
</script>
